/**
 * Quick Actions Section Component
 * Provides quick navigation to key features
 */
import { Search, User, Crown } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

interface QuickAction {
  title: string;
  description: string;
  icon: any;
  color: string;
  action: () => void;
}

interface QuickActionsSectionProps {
  quickActions: QuickAction[];
}

export default function QuickActionsSection({ quickActions }: QuickActionsSectionProps) {
  return (
    <Card className="border-0 shadow-xl bg-gradient-to-br from-blue-50 to-cyan-50">
      <CardHeader>
        <CardTitle className="text-slate-800">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {quickActions.map((action, index) => {
          const Icon = action.icon;
          return (
            <button
              key={index}
              onClick={action.action}
              className="w-full p-4 bg-white rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-md transition-all duration-300 group text-left"
            >
              <div className="flex items-center space-x-3">
                <div className={`p-2 rounded-lg bg-gradient-to-r ${action.color}`}>
                  <Icon className="w-5 h-5 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800 group-hover:text-blue-600">
                    {action.title}
                  </h3>
                  <p className="text-sm text-slate-600">{action.description}</p>
                </div>
              </div>
            </button>
          );
        })}
      </CardContent>
    </Card>
  );
}